import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import SolanaHero from "./SolanaHero";
import WhyChSolana from "./WhyChSolana";
import SolanaDApp from "./SolanaDApp";
import BenefitsOFSolana from "./BenefitsOFSolana";

function Solana() {
  return (
    <div>
      <Header />
      <SolanaHero />
      <WhyChSolana />
      <SolanaDApp />
      <BenefitsOFSolana />
      <Footer />
    </div>
  );
}

export default Solana;
